import axios from "axios";
import env from "../../env.js";

export default {
  GET: async function (data) {
    let host = window.location.host.replace(":8080", "");
    host = host.replace(":8081", "");
    let domain = host.split(".")[0];
    console.log(env.apiKey);
    let url = env.apiUrlPdf;
    // `https://v2.api2pdf.com/chrome/pdf/url?url=https://${domain}.web.app/ctview?ci=${data.id}&apikey=${env.apiKey}`;

    let requestObj = {
      url: url,
      method: "post",
      data: {
        url: `https://${domain}.web.app/ctview?ci=${data.id}`,
        fileName: data.id + ".pdf"
      }
    };
    axios(requestObj)
      .then((response) => {
        const csvFile = new Blob([response.data], {
          type: "application/pdf;charset=utf-8;",
        });


        var temp_link = document.createElement("a");

        temp_link.download = id + ".pdf";
        var url = window.URL.createObjectURL(csvFile);
        temp_link.href = url;
        temp_link.style.display = "none";
        document.body.appendChild(temp_link);
        temp_link.click();
        document.body.removeChild(temp_link);
        return response;
      })
      .catch((error) => {
        return { error: error };
      });
  },
  SEND_HTML: async function (data) {
    let url = env.apiUrlPdf;
    let requestObj = {
      url: url,
      method: "post",
      data: {
        "html": data.html,
        "watermark_url": data.hasOwnProperty('watermark') ? data.watermark : '',
        "inline": false,
        "fileName": (data.hasOwnProperty('name') ? data.name + '.pdf' : 'archivo.pdf'),
        "options": {
          "delay": 0,
          "puppeteerWaitForMethod": "WaitForNavigation",
          "puppeteerWaitForValue": "Load",
          "usePrintCss": true,
          "landscape": data.landscape,
          "printBackground": true,
          "displayHeaderFooter": true,
          "headerTemplate": "<span></span>",
          "footerTemplate": "<span>caca</span>",
          "width": "8.27in",
          "height": "11.69in",
          "marginTop": ".4in",
          "marginBottom": ".4in",
          "marginLeft": ".4in",
          "marginRight": ".4in",
          "pageRanges": "1-10000",
          "watermark": data.hasOwnProperty('watermark') ? data.watermark : '',
          "scale": data.scale,
          "omitBackground": false
        },
        "useCustomStorage": false,

      }
    };

    let r = await axios(requestObj)
      .then((response) => {



        return response;
      })
      .catch((error) => {

        return { error: error }
        //return { error: error };
      });
    return r
  },

  ENVIAR_CORREO: async function (data) {
    let url = env.apiUrlPdf;

    let requestObj = {
      url: url,
      method: "post",
      data: {
        "html": data.html,
        "inline": false,
        "fileName": "test.pdf",
        "options": {
          "delay": 0,
          "puppeteerWaitForMethod": "WaitForNavigation",
          "puppeteerWaitForValue": "Load",
          "usePrintCss": true,
          "landscape": data.landscape,
          "printBackground": true,
          "displayHeaderFooter": false,
          "headerTemplate": "<span></span>",
          "footerTemplate": "<span></span>",
          "width": "8.27in",
          "height": "11.69in",
          "marginTop": ".4in",
          "marginBottom": ".4in",
          "marginLeft": ".4in",
          "marginRight": ".4in",
          "pageRanges": "1-10000",
          "scale": data.scale,
          "omitBackground": false
        },
        "useCustomStorage": false,

      }
    };

    let r = await axios(requestObj)
      .then((response) => {



        return response;
      })
      .catch((error) => {

        return { error: error }
        //return { error: error };
      });
    return r
  },

  DOWNLOAD_PDF_BASE64: function (base64Data, fileName) {
    try {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      return true;
    } catch (error) {
      return { error: error };
    }
  },

};
